import { HttpHeaders } from '@angular/common/http';
import gql from 'graphql-tag';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../shared/services/graph-qlclient.service";
export class NotaVentaService {
    constructor(http, gqlclient) {
        this.http = http;
        this.gqlclient = gqlclient;
        this.headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
    }
    AgregarProducto(payload) {
        return this.http.post(`${environment.API_REST_URL}/document/details/create`, payload, { headers: this.headers });
    }
    AgregarProductoDeNotaEsp(payload) {
        return this.http.post(`${environment.API_REST_URL}/document/details/createNotaEsp`, payload, { headers: this.headers });
    }
    AplicarDescuentoGlobal(proceso, tipoDocumentoDTE, payload) {
        return this.http.post(`${environment.API_REST_URL}/document/update-global-discount?proceso=${proceso}&tipoDocumentoDTE=${tipoDocumentoDTE}`, payload, {
            headers: this.headers,
        });
    }
    EliminarProducto(proceso, ptipo_dte_codigo, linea) {
        // let httpParams = new HttpParams()
        //   .set('proceso', proceso)
        //   .set('ptipo_dte_codigo', ptipo_dte_codigo)
        //   .set('linea', linea)
        return this.http.post(`${environment.API_REST_URL}/document/details/delete/?proceso=${proceso}&ptipo_dte_codigo=${ptipo_dte_codigo}&linea=${linea}`, {
            headers: this.headers,
        });
    }
    EliminarProductoDelEdit(proceso, folio, ptipo_dte_codigo, linea) {
        return this.http.post(`${environment.API_REST_URL}/document/details/deleteprocess/?proceso=${proceso}&folio=${folio}&ptipo_dte_codigo=${ptipo_dte_codigo}&linea=${linea}`, {
            headers: this.headers,
        });
    }
    GuardarProceso(proceso, tipoDocumentoDTE) {
        // let httpParams = new HttpParams()
        //   .set('proceso', proceso)
        //   .set('tipoDocumentoDTE', tipoDocumentoDTE)
        return this.http.post(`${environment.API_REST_URL}/document/create?proceso=${proceso}&tipoDocumentoDTE=${tipoDocumentoDTE}`, {}, { headers: this.headers });
    }
    UpdateProceso(proceso, tipoDocumentoDTE, folio, payload) {
        // let httpParams = new HttpParams()
        //   .set('proceso', proceso)
        //   .set('tipoDocumentoDTE', tipoDocumentoDTE)
        return this.http.post(`${environment.API_REST_URL}/document/update?proceso=${proceso}&tipoDocumentoDTE=${tipoDocumentoDTE}&folio=${folio}`, payload, { headers: this.headers });
    }
    eliminarNotaVenta(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
        mutation ($entidad: procesoInputType) {
          proceso {
            eliminar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo

              }

            }

          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.proceso.eliminar;
            callback({ mensajes, respuesta });
        });
    }
    ObtenerDataEspNotaVenta(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: procesoInputType) {
          proceso {
            obtenerSegunFolio(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                tipo
                texto
                __typename
              }
              respuesta {
                  folio
                  documento
                __typename
              }
              __typename
            }
            __typename
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.proceso.obtenerSegunFolio;
            callback({ mensajes, respuesta });
        });
    }
}
NotaVentaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotaVentaService_Factory() { return new NotaVentaService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.GraphQLClient)); }, token: NotaVentaService, providedIn: "root" });
